import React, { Component } from 'react';
import SVG from 'react-inlinesvg';
import { Formik, Form, FieldArray } from 'formik';
import { isEmpty } from 'lodash';
import classNames from 'classnames/bind';
import { TextField, Divider } from '@material-ui/core';
import trunksSchema from '../../schemas/trunksSchema';
import styles from './trunks.module.scss';

const conditionalStyles = classNames.bind(styles);

export default class Users extends Component {
    constructor(props) {
        super(props);

        this.form = React.createRef();
    }

    componentDidMount() {
        if (!this.form.current.state.values.AbleToComplete) {
            this.form.current.state.values.AbleToComplete = true;

            this.props.updateStep(this.form.current.state.values);
        } else if (this.props.editable) {
            this.form.current.submitForm();
        }
    }

    componentWillUnmount() {
        if (this.props.editable) {
            this.form.current.state.values.Completed = isEmpty(this.form.current.state.errors)
                && !isEmpty(this.form.current.state.touched);

            this.props.updateStep(this.form.current.state.values);
        }
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.fieldsContainer}>
                    <Formik
                        ref={this.form}
                        initialValues={{
                            Key: this.props.formData.key,
                            Completed: this.props.formData.Completed,
                            AbleToComplete: this.props.formData.AbleToComplete,
                            Trunks: this.props.formData.Trunks,
                            TrunksCreated: this.props.formData.TrunksCreated
                        }}
                        enableReinitialize={true}
                        validationSchema={trunksSchema}
                        onSubmit={() => null}
                        render={(props) => (
                            <Form>
                                <FieldArray
                                    name="Trunks"
                                    render={() => (
                                        <div>
                                            {
                                                props.values.Trunks.map((_, index) => (
                                                    <div key={index}>
                                                        <div
                                                            className={
                                                                conditionalStyles({
                                                                    firstSubtitle: index === 0,
                                                                    subtitle: index !== 0,
                                                                })}
                                                        >
                                                            <div className={conditionalStyles({
                                                                subtitleContainer: true,
                                                                inactiveSubtitle: !this.props.editable
                                                            })}>
                                                                <SVG
                                                                    cacheGetRequests={true}
                                                                    className={styles.icon}
                                                                    src="./icons/port.svg"
                                                                />
                                                                <span>{this.props.t('common:PORT')} {index + 1}</span>
                                                            </div>
                                                        </div>
                                                        <div className={styles.row}>
                                                            <TextField
                                                                type="text"
                                                                label={this.props.t('common:TRUNK_NAME')}
                                                                name={`Trunks[${index}].Name`}
                                                                value={props.values.Trunks[index].Name}
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                className={styles.field}
                                                                disabled={!this.props.editable}
                                                                error={
                                                                    (
                                                                        props.touched.Trunks &&
                                                                        props.touched.Trunks[index] &&
                                                                        props.touched.Trunks[index].Name &&
                                                                        props.errors.Trunks &&
                                                                        props.errors.Trunks[index] &&
                                                                        Boolean(props.errors.Trunks[index].Name)
                                                                    ) ||
                                                                    (
                                                                        typeof props.errors.Trunks === 'string'
                                                                    )
                                                                }
                                                                helperText={
                                                                    (
                                                                        props.touched.Trunks &&
                                                                        props.touched.Trunks[index] &&
                                                                        props.touched.Trunks[index].Name &&
                                                                        props.errors.Trunks &&
                                                                        props.errors.Trunks[index] &&
                                                                        Boolean(props.errors.Trunks[index].Name)
                                                                    )
                                                                        ?
                                                                        <span>
                                                                            {this.props.t(
                                                                                `validations:${props.errors.Trunks[index].Name}`
                                                                            )}
                                                                        </span>
                                                                        : (typeof props.errors.Trunks === 'string')
                                                                            ?
                                                                            <span>
                                                                                {this.props.t(
                                                                                    `validations:${props.errors.Trunks}`
                                                                                )}
                                                                            </span>
                                                                            : ''
                                                                }
                                                            />
                                                            <TextField
                                                                type="number"
                                                                inputProps={{
                                                                    min: 1,
                                                                    max: 1000
                                                                }}
                                                                label={this.props.t('common:ACCESS_NUMBER')}
                                                                name={`Trunks[${index}].AccessNumber`}
                                                                value={props.values.Trunks[index].AccessNumber}
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                className={styles.field}
                                                                disabled={!this.props.editable}
                                                                error={
                                                                    (
                                                                        props.touched.Trunks &&
                                                                        props.touched.Trunks[index] &&
                                                                        props.touched.Trunks[index].AccessNumber &&
                                                                        props.errors.Trunks &&
                                                                        props.errors.Trunks[index] &&
                                                                        Boolean(props.errors.Trunks[index].AccessNumber)
                                                                    ) ||
                                                                    (
                                                                        typeof props.errors.Trunks === 'string'
                                                                    )
                                                                }
                                                                helperText={
                                                                    (
                                                                        props.touched.Trunks &&
                                                                        props.touched.Trunks[index] &&
                                                                        props.touched.Trunks[index].AccessNumber &&
                                                                        props.errors.Trunks &&
                                                                        props.errors.Trunks[index] &&
                                                                        Boolean(props.errors.Trunks[index].AccessNumber)
                                                                    )
                                                                        ?
                                                                        <span>
                                                                            {this.props.t(
                                                                                `validations:${props.errors.Trunks[index].AccessNumber}`
                                                                            )}
                                                                        </span>
                                                                        : (typeof props.errors.Trunks === 'string')
                                                                            ?
                                                                            <span>
                                                                                {this.props.t(
                                                                                    `validations:${props.errors.Trunks}`
                                                                                )}
                                                                            </span>
                                                                            : ''
                                                                }
                                                            />
                                                        </div>
                                                        {
                                                            index !== props.values.Trunks.length - 1 &&
                                                            <Divider variant="middle" />
                                                        }
                                                    </div>
                                                ))}
                                        </div>
                                    )}
                                />
                            </Form>
                        )}
                    />
                </div>
            </div>
        );
    }
}
